import { KpiLabelWithDescription } from '@/impactReports/KpiLabelWithDescription.atom';
import type { IHeaderParams } from 'ag-grid-community';
import type { MouseEvent } from 'react';

interface KpiHeaderWithDescriptionProps extends IHeaderParams {
  description?: string | null;
}

export function KpiHeaderWithDescription(props: KpiHeaderWithDescriptionProps) {
  const handleSort = (event: MouseEvent<HTMLDivElement>) => {
    if (!props.enableSorting) return;
    props.progressSort?.(event.shiftKey);
  };

  return (
    <div className="ag-header-cell-label" onClick={handleSort}>
      <span className="ag-header-cell-text">
        <KpiLabelWithDescription label={props.displayName ?? ''} description={props.description} stopIconPropagation />
      </span>
    </div>
  );
}
